import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import State from '../states'
import World, { Props } from '../components/World'
import { World as Actions } from '../actions'

const tileURL = process.env.REACT_APP_TILE_URL
const mapAttribution =
  '<a href="https://www.mapbox.com/about/maps/">&copy; Mapbox &copy; OpenStreetMap</a>'

const mapStateToProps = (state: State): Partial<Props> => ({
  events: state.world.events,
  focusMapObjectID: state.world.player ? state.world.player.id : undefined,
  viewPortUpdatePeriod: 5 * 1000,
  displayAttribution: !!state.login.mobileVersion,
  mapAttribution,
  tileURL
})

const mapDispatchToProps = (dispatch: Dispatch<State>): Partial<Props> => ({
  onMove: (dest, focusMapObjectPosition) => {
    dispatch(Actions.move({ dest, focusMapObjectPosition }))
  },
  onViewPortUpdate: viewPort => {
    dispatch(Actions.viewPortUpdated(viewPort))
  },
  onProcessEvent: (id: string) => {
    dispatch(Actions.eventProcessed(id))
  },
  onMapObjectPress: (id: string) => {
    dispatch(Actions.mapObjectPressed(id))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(World)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/World.tsx